export default "__VITE_ASSET__D2g5Piny__"